import {FieldPath, FieldValues, useFormContext, useWatch} from "react-hook-form";
import {FormControl, FormField, FormItem, FormLabel, FormMessage} from "@/components/ui/form.tsx";
import {Textarea} from "@/components/ui/textarea.tsx";
import {Tabs, TabsContent, TabsList, TabsTrigger} from "@/components/ui/tabs.tsx";
import MarkdownContent from "@/components/markdown/MarkdownContent.tsx";
import {cn} from "@/lib/utils.ts";

export default function MarkdownEditorField<TFieldValues extends FieldValues>({name, title = "Beschreibung", className}: {
    name: FieldPath<TFieldValues>;
    title?: string;
    className?: string;
}) {
    const {control} = useFormContext<TFieldValues>();
    const markdown = useWatch({control, name});

    return <FormField control={control} name={name} render={({field}) => (
        <FormItem className={className}>
            <div className="flex items-center justify-between gap-2">
                <FormLabel>{title}</FormLabel>
            </div>
            <Tabs defaultValue="write" className="gap-2">
                <TabsList className="h-8">
                    <TabsTrigger value="write" className="h-7">Schreiben</TabsTrigger>
                    <TabsTrigger value="preview" className="h-7">Vorschau</TabsTrigger>
                </TabsList>
                <TabsContent value="write">
                    <FormControl>
                        <Textarea {...field} value={field.value ?? ""}
                                  className={cn("min-h-36 resize-y font-mono text-sm")}/>
                    </FormControl>
                </TabsContent>
                <TabsContent value="preview">
                    <MarkdownContent markdown={typeof markdown === "string" ? markdown : ""}
                                     className="min-h-36 rounded-md border bg-background p-3 text-sm"/>
                </TabsContent>
            </Tabs>
            <FormMessage/>
        </FormItem>
    )}/>;
}
